import { createContext } from "react";

const ActivitiModualContext = createContext({});

export default ActivitiModualContext;
